import { useEffect } from 'react';
import { Box } from '@mui/material';

declare let window: {
  AvidWidget: any;
};

export const AvidWidget = () => {
  useEffect(() => {
    window?.AvidWidget?.('stone-martin-builders');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box id="AvidWidgetDiv" padding="3rem 3rem 0" display="flex" alignItems="center" justifyContent="center">
      <link href="https://www.avidratings.com/widgets/static/css/builder/widget.css" rel="stylesheet" />
      <link href="https://www.avidratings.com/widgets/static/css/builder/cleanslate.css" rel="stylesheet" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
                { "@context": "http://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Stone Martin Builders",
                      "image": "https://logos.avidratings.com/stone-martin-builders-logo.png",
                      "aggregateRating":
                        {"@type": "AggregateRating",
                        "ratingValue": "4.1",
                        "reviewCount": "95"
                        }
                    }
              `
        }}
      />
    </Box>
  );
};
